import {useTheme} from "styled-components";

export default useTheme;
